module.exports = __webpack_public_path__ + "static/media/w (6).799af8e7.jpg";